<template>
  <div class="box">
    <span class="title">{{ label }}</span>
    <span class="total">{{ value }}</span>
  </div> 
</template>
<script>
export default {
  name: 'ChartBox',
  props: ['label', 'value']
}
</script>
<style scoped>
.box{
  margin: 20px auto;
  width: 150px;
  height: 100px;
  border: solid 1px #ccc;
  border-radius: 5px;
  padding: 25px;
/*   color: #333333; */
  color: #3F82AA;
  font-weight: bold;
  font-family: Arial;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.box .title{
  font-size: 1.2rem;
}
.box .total{
  margin-top: 12px;
  font-size: 1.8rem;
  color: #333333;
}
</style>